__turbopack_context__.v({
  "ClearButton": "PhoneInput-module-scss-module__xeXeiW__ClearButton",
  "ClearIcon": "PhoneInput-module-scss-module__xeXeiW__ClearIcon",
  "ErrorMessage": "PhoneInput-module-scss-module__xeXeiW__ErrorMessage",
  "Icon": "PhoneInput-module-scss-module__xeXeiW__Icon",
  "InputIcon": "PhoneInput-module-scss-module__xeXeiW__InputIcon",
  "InputWithError": "PhoneInput-module-scss-module__xeXeiW__InputWithError",
  "InputWrapper": "PhoneInput-module-scss-module__xeXeiW__InputWrapper",
  "Label": "PhoneInput-module-scss-module__xeXeiW__Label",
  "PhoneInput": "PhoneInput-module-scss-module__xeXeiW__PhoneInput",
  "Wrapper": "PhoneInput-module-scss-module__xeXeiW__Wrapper",
});
